import { Dates } from './dates.utils';

export class OpeningHours {
    public static sort(openingHours: OLO.DTO.LocationOrderingTimeInfoModel[]): OLO.DTO.LocationOrderingTimeInfoModel[] {
        return [...openingHours].sort((a, b) => {
            const dateCompare = new Date(a.Date).getTime() - new Date(b.Date).getTime();
            if (dateCompare === 0) {
                return a.OpeningTime.localeCompare(b.OpeningTime);
            }

            return dateCompare;
        });
    }

    public static getForDate(openingHours: OLO.DTO.LocationOrderingTimeInfoModel[], date: Date): Nullable<OLO.DTO.LocationOrderingTimeInfoModel> {
        return openingHours.find((oh) => new Date(oh.Date).toDateString() === date.toDateString()) || null;
    }

    public static isWithinOpeningHours(openingHour: OLO.DTO.LocationOrderingTimeInfoModel, time: Date): boolean {
        const timeMinutes = time.getHours() * 60 + time.getMinutes();
        const openMinutes = Dates.timeToMinutes(openingHour.OpeningTime);
        const closeMinutes = Dates.timeToMinutes(openingHour.ClosingTime);

        return timeMinutes >= openMinutes && timeMinutes <= closeMinutes;
    }

    public static getTimeRangeInfo(openingHour: OLO.DTO.LocationOrderingTimeInfoModel, allHours: OLO.DTO.LocationOrderingTimeInfoModel[]): OLO.DTO.TimeRangeInfo {
        const dayRanges = allHours
            .filter((oh) => new Date(oh.Date).toDateString() === new Date(openingHour.Date).toDateString())
            .sort((a, b) => a.OpeningTime.localeCompare(b.OpeningTime));

        return {
            isFirst: dayRanges[0].OpeningTime === openingHour.OpeningTime,
            isLast: dayRanges[dayRanges.length - 1].ClosingTime === openingHour.ClosingTime,
        };
    }

    public static calculateLastPossibleSlot(closingMinutes: number, nextTick: number, endBuffer: number = 0): number {
        const roundedDown = Math.floor(closingMinutes / nextTick) * nextTick;

        return roundedDown - nextTick - endBuffer;
    }
}
